/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLocationCombosRequestInner
 */
export interface UpdateLocationCombosRequestInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationCombosRequestInner
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLocationCombosRequestInner
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the UpdateLocationCombosRequestInner interface.
 */
export function instanceOfUpdateLocationCombosRequestInner(value: object): value is UpdateLocationCombosRequestInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function UpdateLocationCombosRequestInnerFromJSON(json: any): UpdateLocationCombosRequestInner {
    return UpdateLocationCombosRequestInnerFromJSONTyped(json, false);
}

export function UpdateLocationCombosRequestInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLocationCombosRequestInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'enabled': json['enabled'],
    };
}

export function UpdateLocationCombosRequestInnerToJSON(json: any): UpdateLocationCombosRequestInner {
    return UpdateLocationCombosRequestInnerToJSONTyped(json, false);
}

export function UpdateLocationCombosRequestInnerToJSONTyped(value?: UpdateLocationCombosRequestInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'enabled': value['enabled'],
    };
}

